export default "__VITE_ASSET__e1ea5db8__"